<div class="performance-tracker-bar">
   <div class="perf-button perf-image" id="perf-button" *ngIf="perfTrackerItem"
      (click)="activatePerfTracker(perfTrackerItem)" title="{{perfTrackerItem.iconTooltip}}"
      (contextmenu)="showPerfContextMenu(perfTrackerItem, $event)">
      <img class="perf-button" [src]="perfTrackerItem.iconSrc">
   </div>
</div>